module.exports = __webpack_public_path__ + "assets/img/banner.f27f2af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activities/desiagner/banner.png
// module id = 7yxx
// module chunks = 1